export enum PERMISSIONS {
  BLOCK_API_PERSISTANCE = 'block_api_persistance',
}
export enum ROLE {
  DEMO_USER = 'demo_user',
  ADMIN_USER = 'nucleai_admin',
  BETA_TESTER = 'beta_tester',
}
